import { Controller, useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { is, prop } from 'ramda';
import { Input, Message } from '@fasstech/middle-design-system';
import getErrorMessage from '@@viewCommonComponents/controlled/helpers/getErrorMessage.js';
import handleValidationIndicator from '@@viewCommonComponents/controlled/helpers/handleValidationIndicator.js';

const ControlledInput = ({
  hideLabel = false,
  rules = {},
  name,
  label,
  formatValue,
  formatDisplayValue,
  defaultValue,
  containerClassName = '',
  messageClassName = '',
  form,
  withIndicator = true,
  isDisplayed = true,
  displayErrorMessage = false,
  disabled = false,
  ...extraProps
}) => {
  if (!isDisplayed) {
    return null;
  }
  const { setValue } = useFormContext();

  useEffect(() => {
    if (defaultValue) {
      setValue(name, defaultValue);
    }
  }, [defaultValue, name, setValue]);

  const $label = prop('required', rules) ? `${label} *` : label;

  const isValueInvalid = (value) => {
    if (!value || extraProps.number !== true) return false;

    const numericValue = Number(value);
    if (isNaN(numericValue)) return true;

    return (
      (extraProps.min !== undefined && extraProps.min !== -1 && numericValue < extraProps.min) ||
      (extraProps.max !== undefined && extraProps.max !== -1 && numericValue > extraProps.max)
    );
  };

  return (
    <div className={`w-full md:w-[100%]! ${containerClassName}`}>
      <Controller
        name={name}
        control={form.control}
        rules={rules}
        render={(props) => {
          const onChange = (e) => {
            if (extraProps.number) {
              e.target.value = e.target.value.replace(/[^0-9]/g, '');
            }
            if (is(Function, formatValue)) {
              e.target.value = formatValue(e.target.value);
            }
            props.field.onChange(e);
          };
          return (
            <Input
              label={!hideLabel ? $label : ''}
              withIndicator={withIndicator}
              error={handleValidationIndicator(
                props.field.value,
                rules,
                getErrorMessage(form.formState.errors, name),
                isValueInvalid(props.field.value)
              )}
              disabled={disabled}
              {...props}
              {...props.field}
              {...(is(Function, formatDisplayValue) && {
                value: formatDisplayValue(props.field.value)
              })}
              {...extraProps}
              onChange={onChange}
            />
          );
        }}
      />
      {displayErrorMessage && (
        <Message
          className={messageClassName}
          variant="error"
          label={getErrorMessage(form.formState.errors, name)}
        />
      )}
    </div>
  );
};

export default ControlledInput;
